export const GET_FAAS = 'GET_FAAS'; 
export const SET_FAAS = 'SET_FAAS'; 
export const RESET_FAAS = 'RESET_FAAS'